// ScrollMenuの問題で型検査を無視しないとエラーになるため、型チェックは行わない
import * as React from 'react'
import { ScrollMenu } from 'react-horizontal-scrolling-menu'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

import * as Style from './style.css'

interface IFilterItem {
  label: string
  handler: () => void
}

export interface IProps {
  items: IFilterItem[]
}

export const SearchFilter = ({ items }: IProps): JSX.Element => {
  return (
    <ul className={Style.SearchFilter}>
      <ScrollMenu>
        {items.length &&
          items.map((item, index) => (
            <li
              className={Style.SearchFilterItem}
              key={`search-filter-item-${index}`}
            >
              <span className={Style.SearchFilterItemWrapper}>
                <span>{item.label}</span>
                <FontAwesomeIcon icon={faXmark} onClick={item.handler} />
              </span>
            </li>
          ))}
      </ScrollMenu>
    </ul>
  )
}

export default SearchFilter
